const defaultAvatarColors = [
  'primary',
  'secondary',
  'tertiary',
  'quaternary',
  'quinary',
  'senary',
  'septenary',
];

export default defaultAvatarColors;
